<script setup lang="ts">
interface ResetPasswordFields {
  email: string
}

definePageMeta({
  middleware: 'check-no-auth'
})

const apiClient = useAPIClient()
const flash = useFlash()

async function resetPassword(fields: ResetPasswordFields) {  
  const { email } = fields

  try {
    await apiClient.fetch('users/reset', {
      method: 'POST', body: { email }
    })
    flash.set(
      'If your account exists, you should receive a password reset email',
      { kind: 'success', immediate: true }
    )
  } catch (e) {
  }
}
</script>

<template>
  <div class="reset-password page">
    <h1>{{ $t('users.reset_title') }}</h1>

    <div class="content-limit">
      <FlashMessage />

      <FormKit
        type="form"
        :submit-attrs="{ inputClass: 'button' }"
        :submit-label="$t('common.submit')"
        @submit="resetPassword"
      >
        <FormKit
          name="email"
          type="text"
          :label="$t('users.email')"
          validation="required|email"
        />
        <Captcha
          :show="apiClient.showCaptcha.value"
          @verified="p => apiClient.captchaPayload.value = p"
        />
      </FormKit>
    </div>
  </div>
</template>
